import { deregisterFormInstance, registerFormInstance } from "../fluidComponents/fluidForm/FormInstance.service";
import { FluidForm, buildFormConfigItself, stylingForm, actionsForm } from "../../shared";
export const WorkspaceInstances = {
    formConfig: 'formBuilder.formConfig',
    actionsConfig: 'formBuilder.actionsConfig',
    styleConfig: 'formBuilder.styleConfig',
    previewForm: 'formBuilder.previewForm',
};
export function registerWorkspaceInstances() {
    registerFormInstance({ instanceId: WorkspaceInstances.formConfig, form: new FluidForm(buildFormConfigItself()), reset: true });
    registerFormInstance({ instanceId: WorkspaceInstances.actionsConfig, form: new FluidForm(actionsForm), reset: true });
    registerFormInstance({ instanceId: WorkspaceInstances.styleConfig, form: new FluidForm(stylingForm), reset: true });
    registerFormInstance({ instanceId: WorkspaceInstances.previewForm, form: new FluidForm({ key: 'none', type: 'form', fields: [] }), reset: true });
    return () => {
        deregisterFormInstance(WorkspaceInstances.formConfig);
        deregisterFormInstance(WorkspaceInstances.actionsConfig);
        deregisterFormInstance(WorkspaceInstances.styleConfig);
        deregisterFormInstance(WorkspaceInstances.previewForm);
    };
}
